<template>
  <EditorPickLotteryQuickPickCard
    v-model:random="isRandom"
    :headline="$t('picklottery.quickpick.bettype.title')"
  >
    <LcSelect
      :label="$t('picklottery.bettype.label')"
      no-feedback
      no-teleport
      not-nullable
      :options="betTypeOptions"
      :value="betType"
      @update:value="handleSetBetType"
    />

    <p v-if="betType" class="mt-200 text-secondary-secondary paragraph-small-text">
      {{ $t(`lottery.bettype.${betType}.explanation`) }}
    </p>
  </EditorPickLotteryQuickPickCard>
</template>

<script lang="ts" setup>
import type { AddOn, LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  addOn: AddOn
  lotteryId: LotteryId
}

const { addOn, lotteryId } = defineProps<Props>()

const betType = defineModel<Maybe<string>>('value', { required: true })

const { getPerPlayTranslation } = useTranslations()

const betTypeOptions = computed(() =>
  addOn.options.map((option) => ({
    label: getPerPlayTranslation(lotteryId, addOn.name, option),
    value: option,
  })),
)

const isRandom = computed({
  get: () => !betType.value,
  set: (random) => (betType.value = random ? null : (addOn.options[0] ?? null)),
})

const handleSetBetType = (newValue?: Maybe<number | string>) => {
  if (!newValue) return
  betType.value = String(newValue)
}
</script>
